export default "__VITE_ASSET__BvKV2WS9__"